import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const DepartmentMasterPopup = (props) => {
    return (
        <ModalBasic
            id="designationMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Department master</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-2'>
                        <label>Department</label>
                        <TextInput type='text'
                            id='department' name='department'
                            value={props.departmentObject.department}
                            handleChange={(event) => props.handleChange(event, 'department')}
                            className={props.validState?.error?.department !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Person name</label>
                        <MultiSelectDropdown
                            //drpIdentity="Person name"
                            className={props.validState?.error?.authorisedById !== undefined ? "error" : ""}
                            options={props.departmentObject.employeeList}
                            //value={props.departmentObject.idEmployee}
                            value={props.departmentObject.idEmployee ? props.departmentObject.employeeList?.find(item => item.value === props.departmentObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idEmployee")
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Contact no</label>
                        <TextInput type='number'
                            id='contactNo' name='contactNo'
                            value={props.departmentObject.contactNo}
                            handleChange={(event) => props.handleChange(event, 'contactNo')}
                            className={props.validState?.error?.contactNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Email id</label>
                        <TextInput type='text'
                            id='email' name='email'
                            value={props.departmentObject.email}
                            handleChange={(event) => props.handleChange(event, 'email')}
                            className={props.validState?.error?.email !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.departmentObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}